// GoodEnglish1aL01.js
// Good English 1A L01 包装组件
// 路由：/ge/1a/l01
import React from 'react';
import GoodEnglish from './good-english/GoodEnglish';
import { dataGoodEnglish1aL01 } from './good-english/good_english_data_1a_l01';

function GoodEnglish1aL01() {
  return <GoodEnglish data={dataGoodEnglish1aL01} />;
}

export default GoodEnglish1aL01;
